import React, { useEffect, useState } from "react";
import { FormProvider } from "../../../../common/provider/form/Form.provider";
import { CustomButton } from "../../../../common/components/CustomButton/CustomButton";
import { Form, Input, InputNumber, Select } from "antd";
import style from "./style.module.scss";
import { SimpleInput } from "../../../../common/components/simpleInput";
import {
  useQueryMachineMaterialEnergySelect,
  useQueryMachineMaterialFromSelect,
  useQueryMachineMaterialStateSelect,
  useQueryMachineMaterialTypeSelect,
} from "../../core/_hooks";
import { MaterialService } from "../../core/_request";
import { HttpStatusCode } from "axios";
import { InputSelect } from "../../../../common/components/InputSelect/InputSelect";
import { MaterialConstant } from "../../core/_constant";
import { API_URLs } from "../../../../utilities/API_URLs";
import { handleNumericDecimalInput } from "../../../../common/utils/numericInputHandler";

type MachineFormType = {
  onFinish: () => void;
  initialValue?: any;
};

export const MachineForm = ({ onFinish, initialValue }: MachineFormType) => {
  const [form] = Form.useForm();

  const { data: stateOptions, isLoading: isLoadingState } =
    useQueryMachineMaterialStateSelect();
  const { data: energyOptions, isLoading: isLoadingEnergy } =
    useQueryMachineMaterialEnergySelect();
  const { data: fromOptions, isLoading: isLoadingFrom } =
    useQueryMachineMaterialFromSelect();
  const { data: typeOptions, isLoading: isLoadingType } =
    useQueryMachineMaterialTypeSelect();

  const [isLoadingSubmit, setIsLoadingSubmit] = useState<boolean>(false);

  const [selectedOwner, setSelectedOwner] = useState<any>("");
  const [selectedType, setSelectedType] = useState<any>("");

  useEffect(() => {
    if (initialValue) {
      setSelectedType(initialValue?.machineMaterialType?.id);
      setSelectedOwner(initialValue?.materialFrom?.id);
      form.setFieldsValue({
        ...initialValue,
        machineMaterialType: initialValue?.machineMaterialType
          ? {
              label: initialValue?.machineMaterialType?.name,
              value: initialValue?.machineMaterialType?.["@id"],
            }
          : null,
        materialEnergy: initialValue?.materialEnergy
          ? {
              label: initialValue?.materialEnergy?.name,
              value: initialValue?.materialEnergy?.["@id"],
            }
          : null,
        driver: initialValue?.driver
          ? {
              label: initialValue?.driver?.fullname,
              value: initialValue?.driver?.["@id"],
            }
          : null,
        materialFrom: initialValue?.materialFrom
          ? {
              label: initialValue?.materialFrom?.name,
              value: initialValue?.materialFrom?.["@id"],
            }
          : null,
        materialState: initialValue?.materialState
          ? {
              label: initialValue?.materialState?.name,
              value: initialValue?.materialState?.["@id"],
            }
          : null,
      });
    }
  }, [initialValue]);

  const onSubmitHandler = async (values: any) => {
    try {
      setIsLoadingSubmit(true);
      const dataToPost = {
        ...values,
        ...(initialValue
          ? {
              "@id": initialValue?.["@id"],
            }
          : {}),
        capacity: values?.capacity?.toString(),
        machineMaterialType: values?.machineMaterialType
          ? values?.machineMaterialType?.value
          : null,
        materialEnergy: values?.materialEnergy
          ? values?.materialEnergy?.value
          : null,
        materialFrom: values?.materialFrom ? values?.materialFrom?.value : null,
        materialState: values?.materialState
          ? values?.materialState?.value
          : null,
        driver: values?.driver?.value ?? null,
      };

      if (!dataToPost?.id) {
        const res = await MaterialService.createMachineMaterial(dataToPost);

        if (res?.status === HttpStatusCode.Created) {
          onFinish();
          form?.resetFields();
        }
      } else {
        const res = await MaterialService.updateMachineMaterial(dataToPost);
        if (res?.status === HttpStatusCode.Ok) {
          onFinish();
          form?.resetFields();
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingSubmit(false);
    }
  };

  const getDriverParams = (type: string) => {
    switch (type) {
      case MaterialConstant.MACHINE_TYPE.TRUCK:
        return "DRIVER";
      case MaterialConstant.MACHINE_TYPE.ELEVATOR:
        return "MACHINE_OPERATOR";
      case MaterialConstant.MACHINE_TYPE.STACKER:
        return "MACHINE_OPERATOR";

      default:
        return "";
    }
  };

  return (
    <div>
      <FormProvider
        Form={Form}
        form={form}
        debug={true}
        onFinish={(values: any) => {
          onSubmitHandler(values);
        }}
        onFinishFailed={(err) => {
          console.log("err", err);
        }}
      >
        <div className="d-none">
          <SimpleInput
            Form={Form}
            label="ID"
            name={"id"}
            customInput={<Input />}
          />
        </div>
        <div className={style.form}>
          <div className={style.form__item_wrapper}>
            <div className={style.form__item}>
              <SimpleInput
                Form={Form}
                label="Référence"
                name={"reference"}
                rules={[
                  {
                    required: true,
                    message: `Ce champ est requis`,
                  },
                ]}
                customInput={<Input />}
              />
            </div>
            <div className={style.form__item}>
              <SimpleInput
                Form={Form}
                label="Capacité (T)"
                name={"capacity"}
                rules={[
                  {
                    required: true,
                    message: `Ce champ est requis`,
                  },
                ]}
                customInput={
                  <InputNumber min={0} className={style.form__input} onKeyDown={handleNumericDecimalInput}/>
                }
              />
            </div>
          </div>

          <div className={style.form__item_wrapper}>
            <div className={style.form__item}>
              <SimpleInput
                Form={Form}
                label="Propriétaire"
                name={"materialFrom"}
                rules={[
                  {
                    required: true,
                    message: `Ce champ est requis`,
                  },
                ]}
                customInput={
                  <Select
                    labelInValue
                    options={fromOptions}
                    loading={isLoadingFrom}
                    onChange={(e: any) => {
                      form.setFieldValue("driver", null);
                      setSelectedOwner(e?.key);
                    }}
                  />
                }
              />
            </div>
            <div className={style.form__item}>
              <SimpleInput
                Form={Form}
                label="Type"
                name={"machineMaterialType"}
                rules={[
                  {
                    required: true,
                    message: `Ce champ est requis`,
                  },
                ]}
                customInput={
                  <Select
                    labelInValue
                    options={typeOptions}
                    loading={isLoadingType}
                    onChange={(e) => {
                      console.log("aaaa", e);
                      form.setFieldValue("driver", null);
                      setSelectedType(e?.key);
                    }}
                  />
                }
              />
            </div>
          </div>
          {selectedOwner === MaterialConstant.OWNER_TYPE.SEMS ? (
            <div className={style.form__item_wrapper}>
              <div className={style.form__item}>
                <SimpleInput
                  Form={Form}
                  label="Conducteur"
                  name={"driver"}
                  customInput={
                    <InputSelect
                      disabled={!selectedType}
                      uri={API_URLs.staff.getStaffForSelect}
                      valueOption={{
                        labelKey: "fullname",
                        valueKey: "@id",
                      }}
                      params={{
                        staffPost: getDriverParams(selectedType),
                      }}
                      onChange={(e) => console.log("aaaaa", e)}
                    />
                  }
                />
              </div>
            </div>
          ) : selectedOwner === MaterialConstant.OWNER_TYPE.COMAMA ? (
            <div className={style.form__item_wrapper}>
              <div className={style.form__item}>
                <SimpleInput
                  Form={Form}
                  label="Conducteur"
                  name={"comamaDriverName"}
                  customInput={<Input />}
                />
              </div>
            </div>
          ) : ""}

          <div className={style.form__item_wrapper}>
            <div className={style.form__item}>
              <SimpleInput
                Form={Form}
                label="Etat"
                name={"materialState"}
                rules={[
                  {
                    required: true,
                    message: `Ce champ est requis`,
                  },
                ]}
                customInput={
                  <Select
                    labelInValue
                    options={stateOptions}
                    loading={isLoadingState}
                  />
                }
              />
            </div>
            <div className={style.form__item}>
              <SimpleInput
                Form={Form}
                label="Energie"
                name={"materialEnergy"}
                customInput={
                  <Select
                    labelInValue
                    options={energyOptions}
                    loading={isLoadingEnergy}
                  />
                }
              />
            </div>
          </div>
        </div>
        <div className={style.form__action_wrapper}>
          <CustomButton
            type="submit"
            className={style.form__action_button}
            isLoading={isLoadingSubmit}
          >
            Enregistrer
          </CustomButton>
        </div>
      </FormProvider>
    </div>
  );
};
